var _style, _g, _path, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoRows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Objects",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 312",
    style: {
      enableBackground: "new 0 0 480 312"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#E9EAF5;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#DDDFEF;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{opacity:0.25;fill-rule:evenodd;clip-rule:evenodd;fill:#4673B7;enable-background:new    ;}\n\t.st4{fill:#F7C5B4;}\n\t.st5{fill:#D1D3D3;}\n\t.st6{fill:#80B0E1;}\n\t.st7{fill:#3C3C3B;}\n\t.st8{fill:#A4C6D3;}\n\t.st9{fill:none;stroke:#72A2A5;stroke-width:1.0653;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st10{fill:#F5ED82;}\n\t.st11{fill:#C2914D;}\n\t.st12{fill:#DA806C;}\n\t.st13{fill:#222221;}\n\t.st14{opacity:0.9;fill:#F5ED82;}\n\t.st15{fill:none;stroke:#3C3C3B;stroke-width:1.0115;stroke-miterlimit:10;}\n\t.st16{fill:none;stroke:#5A6279;stroke-width:5.5642;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st17{fill:#585E91;}\n\t.st18{fill:none;}\n\t.st19{fill:none;stroke:#3C3C3B;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st20{fill:#EE7677;}\n\t.st21{fill:#E89B8D;}\n\t.st22{fill:#9EADE5;}\n\t.st23{fill:#8496E5;}\n\t.st24{opacity:0.69;fill:#F7C5B4;}\n\t.st25{fill:#6EC4AF;}\n\t.st26{fill:#92D5AC;}\n\t.st27{fill:#7C6990;}\n\t.st28{fill:#7879A5;}\n\t.st29{opacity:0.42;fill:#B8B8DD;}\n\t.st30{fill:#BDC1C0;}\n\t.st31{fill:#CEA1A5;}\n\t.st32{opacity:0.88;fill:#BDC1C0;}\n\t.st33{fill:#7E524F;}\n\t\n\t\t.st34{fill:none;stroke:#4183B6;stroke-width:1.0317;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:3.0952;}\n\t.st35{fill:#FFACB9;}\n\t.st36{opacity:0.59;fill:#FFACB9;}\n\t.st37{opacity:0.71;fill:#F7C5B4;}\n\t.st38{fill:#70B0E1;}\n\t.st39{fill:#FF8E93;}\n\t.st40{fill:none;stroke:#FF8E93;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st41{fill:#FFBEC3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300.5,111.1c-53.8-32.5-79.2-132.4-162.3-72.7s-48.6,182.3,31.1,212s182,12.9,210.8-42.2 C429.3,114,336.6,132.9,300.5,111.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.1,206.6c21.1-8.9,51.9-15.2,90.5-4.2c69.8,19.9,113.5,6.1,113.5-84.2c41.3,11.6,104.2,8.9,61.8,90 c-28.8,55.1-131.2,71.9-210.8,42.2C146.7,242,127.8,226.2,114.1,206.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M222.2,69.3l-0.7-2.1l-0.7,2.1c-0.6,1.8-2.1,3.3-4,4.2c1.9,0.9,3.4,2.4,4,4.2l0.7,2.1l0.7-2.1 c0.6-1.8,2.1-3.3,4-4.2C224.2,72.6,222.7,71.1,222.2,69.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M156.5,188.5l-0.7-2.1l-0.7,2.1c-0.6,1.8-2.1,3.3-4,4.2c1.9,0.9,3.4,2.4,4,4.2l0.7,2.1l0.7-2.1 c0.6-1.8,2.1-3.3,4-4.2C158.6,191.6,157.1,190.1,156.5,188.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M353.4,175.9l-0.4-1.3l-0.4,1.3c-0.4,1.2-1.3,2.1-2.7,2.7c1.3,0.6,2.2,1.5,2.7,2.7l0.4,1.3l0.4-1.3 c0.4-1.2,1.3-2.1,2.7-2.7C354.7,178.1,353.8,177,353.4,175.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M124.7,106.8l-0.4-1.3l-0.4,1.3c-0.4,1.2-1.3,2.1-2.7,2.7c1.3,0.6,2.2,1.5,2.7,2.7l0.4,1.3l0.4-1.3 c0.4-1.2,1.3-2.1,2.7-2.7C126,108.8,125.1,108,124.7,106.8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M336.8,281.5c3.5-0.9,5.3-1.9,5.3-3c0-5.4-50-9.8-111.7-9.8s-111.7,4.4-111.7,9.8c0,2.6,11.9,5,31.3,6.8 c-3.5,0.9-5.3,1.9-5.3,3c0,5.4,50,9.8,111.7,9.8s111.7-4.4,111.7-9.8C368.1,285.6,356.2,283.2,336.8,281.5z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1411_",
    className: "st4",
    d: "M193.8,272.7l-0.5,4.9c0,0,3.4,1.2,7.5,0c0,0,2.1-0.6,3-1.2l0.2-2.8L193.8,272.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1399_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1410_",
    className: "st5",
    d: "M192.4,280.2c0,0.5,0,1,0,1.6c0,0.3,0,0.7,0.2,1c0.3,0.5,0.9,0.7,1.4,0.8 c1.7,0.5,12.5,3.1,17,1.7c1.4-0.4,3-1,3.2-2.4c0.3-1.4-1.1-2.3-2.3-3l-19.4-1.3L192.4,280.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1409_",
    className: "st6",
    d: "M192.4,280.2c0-1.1,0-1.6,0.6-3.4l1.7,0.3c1.9,0.3,3.4-0.1,3.4-0.1s3.6-0.8,5.8-2 c0,0,2.1,1.6,3.1,2.2c1.7,0.9,3.3,1.9,5,2.8l0,0.1c-0.4,0-0.8,0.2-1.2,0.4c-0.6,0.4-1.2,0.9-1.7,1.5c-0.2,0.2-0.4,0.5-0.5,0.8 c-0.1,0.3-0.2,0.6-0.1,0.9C202.9,284,197.1,282.9,192.4,280.2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1400_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1407_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M209.6,278.8c-1.1,0.2-1.9,1-2.4,2c0,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.1-0.1-0.1-0.2c0.2-1.2,1.4-2.2,2.6-2.2 C209.8,278.5,209.8,278.8,209.6,278.8L209.6,278.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1405_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M208.1,278c-1.1,0.4-1.9,1.1-2.4,2.1c0,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.1-0.1-0.1-0.2 c0.3-1.2,1.5-2.1,2.7-2.3C208.2,277.7,208.2,277.9,208.1,278L208.1,278z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1403_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M206.6,277.2c-1.1,0.3-1.9,1-2.4,2c0,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.1-0.1-0.1-0.2c0.2-1.2,1.4-2.2,2.6-2.2 C206.7,276.9,206.8,277.1,206.6,277.2L206.6,277.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1401_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M205,276.2c-1,0.5-2.1,1-2.2,2.2c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.1-0.1-0.1-0.1c-0.2-1.4,1.3-2.3,2.4-2.5 C205.1,275.9,205.1,276.1,205,276.2L205,276.2z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1396_",
    className: "st4",
    d: "M171.4,272.6l-0.5,4.9c0,0,3.4,1.2,7.5,0c0,0,2.1-0.6,3-1.2l0.2-2.8L171.4,272.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1382_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1395_",
    className: "st5",
    d: "M170,280.1c0,0.5,0,1,0,1.6c0,0.3,0,0.7,0.2,1c0.3,0.5,0.9,0.7,1.4,0.8 c1.7,0.5,12.5,3.1,17,1.7c1.4-0.4,3-1,3.2-2.4c0.3-1.4-1.1-2.3-2.3-3l-19.4-1.3L170,280.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1394_",
    className: "st6",
    d: "M170,280.1c0-1.1,0-1.6,0.6-3.4l1.7,0.3c1.9,0.3,3.4-0.1,3.4-0.1s3.6-0.8,5.8-2 c0,0,2.1,1.6,3.1,2.2c1.7,0.9,3.3,1.9,5,2.8l0,0.1c-0.4,0-0.8,0.2-1.2,0.4c-0.6,0.4-1.2,0.9-1.7,1.5c-0.2,0.2-0.4,0.5-0.5,0.8 c-0.1,0.3-0.2,0.6-0.1,0.9C180.5,284,174.7,282.8,170,280.1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1383_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1392_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M187.2,278.7c-1.1,0.2-1.9,1-2.4,2c0,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.1-0.1-0.1-0.2c0.2-1.2,1.4-2.2,2.6-2.2 C187.4,278.4,187.4,278.7,187.2,278.7L187.2,278.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1390_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M185.7,277.9c-1.1,0.4-1.9,1.1-2.4,2.1c0,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.1-0.1-0.1-0.2 c0.3-1.2,1.5-2.1,2.7-2.3C185.8,277.6,185.8,277.9,185.7,277.9L185.7,277.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1386_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M184.2,277.1c-1.1,0.3-1.9,1-2.4,2c0,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.1-0.1-0.1-0.2c0.2-1.2,1.4-2.2,2.6-2.2 C184.4,276.8,184.4,277.1,184.2,277.1L184.2,277.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1384_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M182.6,276.1c-1,0.5-2.1,1-2.2,2.2c0,0.1-0.1,0.2-0.2,0.1c-0.3-0.1-0.1-0.9,0-1.1c0.4-0.9,1.4-1.3,2.3-1.5 C182.7,275.8,182.7,276,182.6,276.1L182.6,276.1z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1381_",
    className: "st4",
    d: "M211.7,155.9c-3.2-5.8-6.7-15.7-6.7-15.7c-2.3-5.4-6.3-19.6-6.1-25.6l6.4-4.1 c0.1,1.6,4.5,19.3,5.4,23.1c1.4,6.3,3.3,12.6,6.2,18.4c0.3,0.6,1.2,0.9,1.9,1c0.4,0,0.7,0,1.1,0.1c0.3,0.1,0.7,0.4,0.7,0.7 c0.1,0.4-0.3,0.9-0.7,1c-0.4,0.1-0.9,0.1-1.3,0c0.1,1.4,2.7,1.9,2.7,2.9c-0.2,0.9-1.1,0.8-1.7,0.7c-0.6-0.1-1.2-0.5-1.7-0.9 c0.3,0.7,1.4,0.9,1.5,1.7c0.1,0.6-0.6,1.2-1.3,1.1c-0.6-0.1-1.2-0.5-1.7-0.9c0.3,0.3,0.6,0.6,0.7,1c0.1,0.4,0,0.9-0.3,1.1 c-0.5,0.3-1-0.1-1.3-0.5c-0.3-0.4-0.5-1-0.9-1.3c0.1,0.3,0.3,0.7,0.2,1.1c0,0.4-0.3,0.8-0.7,0.8c-0.4,0-0.6-0.3-0.8-0.6 C212.2,159.6,211.6,157.7,211.7,155.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1369_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1380_",
    className: "st8",
    d: "M188.3,171.2c-0.1,25-2.9,78.2-6.3,103h-11.5c-3.2-17.5-2.1-42.4-1.1-57 c0.5-7.4,0.2-14.9-1.1-22.2c-2-11.5-4.1-30.7,0.6-47l34.2,1.1c0.8,6.8,2.2,14.8,2.6,21.6c1.9,33.9,1.7,48.3-0.7,103.5h-12.6 C192.1,247.8,191.4,197.3,188.3,171.2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1378_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M190.3,170.8c-1.4,0.7-3,0.6-4.5,0.2c-0.1,0-0.1-0.1-0.1-0.2c0-0.1,0.1-0.1,0.2-0.1c1.4,0,2.9,0.2,4.3-0.2 C190.3,170.4,190.5,170.7,190.3,170.8L190.3,170.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1376_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M189.4,155.6c0.2,3.4,0.2,7.1,0.3,10.5c0.2,1.7-1.9,1.6-3,1.4c-0.2,0-0.2-0.4,0.1-0.3c1.5,0.1,2.6,0.1,2.4-1 c0,0-0.1-3.5-0.1-3.5c0-2.3-0.1-4.7,0-7C189,155.4,189.4,155.4,189.4,155.6L189.4,155.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1373_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M176.8,151.5c-1.1,3.2-3.7,6.1-7.1,6.9c-0.2,0-0.3-0.3-0.1-0.3c3.1-1.1,5.5-3.7,6.9-6.7 C176.6,151.2,176.8,151.3,176.8,151.5L176.8,151.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1371_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M199.3,152.7c0.8,2.1,2.7,3.2,4.4,4.5c0.1,0.1,0.1,0.2,0,0.2c-0.1,0.1-0.1,0.1-0.2,0.1c-1.9-1-4-2.4-4.5-4.7 C199,152.6,199.2,152.5,199.3,152.7L199.3,152.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1370_",
    className: "st9",
    d: "M169.3,150.6c-3.2,21-0.1,32.2,1.7,52.8c0.5,5.6-1.8,49.5,0.5,69.2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1368_",
    className: "st10",
    d: "M206.3,110.7c-0.5-1.6-1.7-5.1-2.3-6.5c0,0,0,0,0,0l0,0c-1.7-3.6-4-6.5-7.5-8.1 c0,0-0.8-0.3-2.1-0.5c-1-0.2-2.3-0.2-3.9-0.2l-12.9-0.6c-1.9-0.4-6.5,1.2-9,6.2c-1.1,2.2-1.5,4.7-1.4,7.2l1.2,18.5 c0,0,0.9,14.8-0.2,22.1c0.6,0.1,15.4,3.7,24.6,3.2c8.1-0.5,10.8-2,10.8-2l-2.5-15.5c-1-16.4-1.7-9.9-2-20.3L206.3,110.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M198.5,71.9c0,1.1,0,2.2-0.2,3.3c-0.2,1.1-0.6,2.2-1.3,3.1c-0.2,0.2-0.4,0.4-0.6,0.3c-0.2-0.7-0.1-1.3,0-2 c0.1-2.4-0.6-4.7-1-7c0-0.3-0.5-1.9,0.6-2.3c0.8-0.3,2.1-1.1,2.2,0C198.4,68.4,198.5,70.7,198.5,71.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1367_",
    className: "st4",
    d: "M190.2,95l-0.6-8.8l-9.1-0.1l-0.5,8.7l-2.9-0.1c0,0,1.1,5,10,5.3c0,0,6.3,0.2,7.4-4.4 L190.2,95z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1366_",
    className: "st4",
    d: "M174.4,67.6c-0.7,4.8,0.4,11.9,1.5,15.6c0.5,1.5,1,3.1,2,4.3c5.1,6,11.5,3.8,13.6,2.4 c1.6-1.2,2.9-2.7,3.6-4.6c1.8-4.8,2.5-10,1.8-15.1c0,0-1.1-11.7-12.7-10.3C184.3,59.9,175.6,59.6,174.4,67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1365_",
    className: "st7",
    d: "M188.2,91.2c0,0-3.8,1.3-7.9-1.6l-0.1,1.8C180.1,91.5,184.7,93.9,188.2,91.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M195.8,69.6c-4.6,1.8-10.2,0.6-13.7-2.8c1.1,1.6,2.4,3,3.9,4.1c-1.3,0.5-2.8,0.5-4.2,0.2 c-1.4-0.3-2.7-0.9-4-1.6c0,1.7-0.3,3.5-0.7,5.2c-0.4,1.6-1.2,3.2-2.6,4.2c-1-1.1-1.3-2.7-1.4-4.1c-0.2-2.5,0-5.1,0.5-7.6 c0.2-1,0.5-2,0.9-2.9c0.6-1.3,1.7-2.3,2.8-3.2c3.1-2.4,7.6-3.2,11.1-1.5c1.8,0.9,4-0.3,5.7-1.3c0,1-0.3,1.9-0.7,2.8 c1.9,0.3,3.7-0.7,5.3-1.6c0.1,1.2-0.3,2.4-0.9,3.4c0.6-0.1,1.1-0.3,1.7-0.4C199.5,67.6,196.5,69.4,195.8,69.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1358_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1364_",
    className: "st4",
    d: "M175.4,81c-0.3,0.5-1,0.7-1.6,0.5c-0.4-0.1-0.8-0.5-1-0.8c-0.7-0.9-1.2-2.2-0.9-3.3 c0.1-0.3,0.2-0.6,0.4-0.8c0.4-0.3,0.9-0.3,1.4-0.1c0.4,0.2,1.3,1.2,1.8,1.7L175.4,81z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1359_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1362_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M172.9,77.5c1.1,0.3,2,1.2,2.3,2.3c0,0.1-0.2,0.2-0.2,0.1c-0.5-0.9-1.2-1.7-2.1-2.1 C172.7,77.6,172.8,77.4,172.9,77.5L172.9,77.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1360_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M174.4,78.7c-0.3,0.6-0.5,1.3-0.4,1.9c0,0.1,0,0.1-0.1,0.1c-0.5-0.3-0.1-1.9,0.4-2.2 C174.4,78.5,174.5,78.6,174.4,78.7L174.4,78.7z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M196.3,95.4c1.2,6.5,1.6,11.1,2.3,16.9c0,0,10.5,49.3,9.1,84.6c0,0-6.1,2.4-19,3.1 c-12.9,0.7-16.9-1.6-16.9-1.6s3.3-65,3.3-72.2c0-7.3,1.8-24-0.5-30.9c0,0,0.9-0.9,2.9-0.8c0,0,1,0,1.1,0.4c2,5.1,3.1,10.5,3.1,15.9 c4.3,0.9,8.7,0.7,13.1,0.4c0.2-1.8-1.1-14.2-1.4-16L196.3,95.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1357_",
    className: "st14",
    d: "M168.3,123.3l0.2,3.3c0,0,0.9,14.8-0.2,22.1c0.6,0.1,15.4,3.7,24.6,3.2 c1.6-0.1,3.1-0.2,4.3-0.4c-0.3,0.3-23,2.1-25-9.4C170.3,131,168.3,123.3,168.3,123.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1356_",
    className: "st15",
    d: "M197.9,96.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1355_",
    className: "st16",
    d: "M188,168.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M197.6,118.1l-0.8,0.6c-7.1,5-3.1,2.4-10.4,8.2c-1.7-2.8-4.4-7.9-6.7-11.4l-8.6,4.6c2.5,3.8,6.6,11.1,9.5,14.6 c1.1,1.3,2.3,2.6,4,2.9c1.7,0.3,3.4-0.6,4.8-1.7c5-3.8,8.9-12,13.2-16.5l0.8-0.9c1.3,0.1,2.7-0.1,3.8-0.6c0.3-0.1,1.6-0.8,1.4-1.1 c-2.8,0-7.4,0-10.2,0.1c-0.2,0-0.4,0-0.6,0.1C197.5,117.1,197.6,117.7,197.6,118.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M200.5,121.8c0.8-1.2,1.7-2.5,2.7-3.5c1.8-0.1,3.7-0.1,5.3-1.3c-1.3,1.4-3.3,1.8-5.2,1.7c0,0,0.2-0.1,0.2-0.1 C202.7,119.5,201.5,120.9,200.5,121.8L200.5,121.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M220.7,116.9h-33.8c-0.4,0-0.8-0.3-0.8-0.8v0c0-0.4,0.3-0.8,0.8-0.8h33.8c0.4,0,0.8,0.3,0.8,0.8v0 C221.5,116.6,221.2,116.9,220.7,116.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M214.7,118.8c0,0.2,0,0.4,0,0.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M174,149.5c-2.1,0.3-4.3-0.3-6-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M167.8,147.5c-0.6-1.8-1.5-3.6-2.5-5.2c-0.2-0.3-0.5-0.7-0.8-0.8c-0.5-0.1-1,0.4-1.1,0.9 c-0.1,0.5,0.1,1,0.3,1.5c0.6,1.3,1.6,2.5,2.8,3.3c0.3,0.2,0.7,0.5,0.9,0.8c0.1,0.2,0.1,0.4,0.1,0.6c0.2,2.1,0.1,4.2-0.4,6.2 c-0.7,3-2.2,6-1.8,9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1348_",
    className: "st7",
    d: "M185.2,81.9c0.2-0.2,0.5-0.3,0.7-0.3c0.3,0,0.5,0.1,0.8,0.2c0.4,0.1,0.8,0.1,1.2,0.1 c0.2,0,0.4-0.1,0.6-0.1c0.2,0,0.5,0,0.6,0.2c0.2,0.2,0.2,0.5,0.1,0.8c-0.1,0.3-0.3,0.5-0.5,0.7c-0.7,0.5-1.6,0.8-2.4,0.5 C185.6,83.6,185,82.8,185.2,81.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1325_",
    className: "st20",
    d: "M185.2,82.8c0.4-0.1,0.8-0.1,1.1-0.1c0.8,0,1.7,0.3,2.3,0.8c0,0-0.6,0.8-1.9,0.6 C185.5,83.8,185.2,82.8,185.2,82.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1321_",
    className: "st7",
    d: "M181.6,78.8c0,0.4,0.4,0.6,0.8,0.6c0.4,0,0.6-0.4,0.6-0.8c0-0.4-0.4-0.6-0.8-0.6 C181.8,78.1,181.5,78.4,181.6,78.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1312_",
    className: "st7",
    d: "M192.3,78.7c0,0.4,0.4,0.6,0.8,0.6c0.4,0,0.6-0.4,0.6-0.8c0-0.4-0.4-0.6-0.8-0.6 C192.5,78,192.2,78.3,192.3,78.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1299_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M183.6,76.5c-1.3,0-2.5,0.3-3.6,0.9c-0.1,0.1-0.3,0-0.4-0.1c0-0.1,0-0.2,0-0.3c1-1.1,2.7-1.5,4.1-0.9 C183.9,76.1,183.8,76.5,183.6,76.5L183.6,76.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1296_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M190.8,76.4c1.2-0.9,3-0.8,4.2,0.1c0.2,0.2,0,0.6-0.2,0.5c-1.3-0.4-2.5-0.4-3.7-0.1 C190.7,76.9,190.5,76.5,190.8,76.4L190.8,76.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1294_",
    className: "st21",
    d: "M188.2,75.7c0.2,1.5,0.1,2.9,0.2,4.4c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.3,0.1-0.5,0.1 c-0.3,0-0.6,0-0.8,0c-0.1,0-0.3,0-0.4-0.1c0-0.1-0.1-0.1-0.1-0.2c0-1.4,0.1-2.9,0.4-4.3c0-0.1,0.1-0.3,0.2-0.4 c0.1-0.2,0.4-0.2,0.7-0.1C187.9,75.3,188.2,75.4,188.2,75.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M193.9,109h20.6c0,0-2.3,6.7-10.3,6.7C195.5,115.7,193.9,109,193.9,109z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.5,
    y: 108.1,
    className: "st23",
    width: 21.2,
    height: 0.9
  })), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M179.8,115.4c0,0-6.8,4-8.6,4.6l0.9,1.3c0,0,7-3.9,8.2-5.2L179.8,115.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1350_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M175.7,102.9c1.2,6.4,2.3,8.7,4.4,12.2c-3.1,1.8-6.2,3.8-9.5,5.2c-1-1.5-1.3-2.3-2.4-5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M175.7,102.9c0.9,4.2,2.2,8.4,4.7,12c0.1,0.1,0,0.3-0.1,0.4c0,0-4.7,2.7-4.7,2.7c-1.6,0.9-3.2,1.7-4.9,2.4 c-0.1,0-0.2,0-0.2-0.1c-1.1-1.6-1.7-3.5-2.2-5.4c0.7,1.8,1.4,3.6,2.5,5.2c0,0-0.2-0.1-0.2-0.1c3.3-1.4,6.3-3.5,9.5-5.2 c0,0-0.1,0.4-0.1,0.4C177.4,111.6,176.2,107.2,175.7,102.9L175.7,102.9z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1479_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1483_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1495_",
    className: "st25",
    d: "M340.1,168.1c-1.7-1.2-4.7-3.2-6-4.9c-0.6-0.7-1.1-1.6-1.2-2.5c-0.1-0.9,0.2-2,0.9-2.5 c0.3-0.2,2.7-0.3,2.8-2.3c0-1.1-1.9-2.6-2.7-3.3c-0.6-0.6-1.2-1.2-1.6-1.9c-0.5-0.9-1-2.2-0.8-3.3c0.2-0.8,0.9-1.5,1.7-1.6 c0.6,0,2.7,1.3,3.4,0.3c0.2-0.3,0.3-0.6,0.3-1c0.1-0.8,0.2-2.5,0.4-3.2c0.2-1.6,0.9-3,1.9-4.2c0.5-0.6,1.1-1,1.8-1.2 c2.5-0.7,4,1.9,4,4.2c0,2.2-1,4.3-0.8,6.5c0,0.5,0.3,0.9,0.7,1.2c1,0.6,1.8-0.3,2.8-0.5c0.9-0.1,1.7,0.5,2.1,1.3 c0.4,0.8,0.4,1.7,0.2,2.6c-0.3,1.6-1.1,3-2.2,4.1c-0.4,0.4-0.8,0.7-1.1,1.1s-0.4,1-0.1,1.5c0.4,0.5,1.1,0.5,1.7,0.8 c0.9,0.5,1,1.7,0.7,2.6c-0.4,0.9-1.2,1.6-2,2.1C345.3,165.2,342.2,167.4,340.1,168.1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1493_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M341.7,140.9c-1.5,8.7-0.9,17.8-0.8,26.6c0,3,0,5.9-0.4,8.9c0,0.2-0.2,0.3-0.4,0.3c-0.2,0-0.3-0.1-0.3-0.3 c-0.7-5.9-0.5-11.9-0.2-17.8c0.4-5.9,0.7-11.9,1.5-17.8C341.1,140.3,341.8,140.4,341.7,140.9L341.7,140.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1491_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M340,153.4c-2.1-1.7-5.5-2.1-6.7-4.8c-0.1-0.3,0.2-0.6,0.5-0.5c2.7,0.8,4,3.7,6.5,4.7 C340.7,153,340.4,153.7,340,153.4L340,153.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1488_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M340,164.3c-2.3-0.6-5.5-1.1-6.3-3.8c0.1-1.2,1.8,0.1,2.1,0.5c1.2,1.2,2.5,2.6,4.3,2.7 C340.6,163.6,340.5,164.4,340,164.3L340,164.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1486_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M339.8,157.8c3.2-1.3,4.8-4.6,7.9-6c0.3-0.1,0.6,0.2,0.5,0.5c-0.6,1.7-2.2,2.7-3.6,3.6 c-1.5,0.8-3,1.7-4.4,2.5C339.8,158.6,339.4,158,339.8,157.8L339.8,157.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1484_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M339.8,164.9c2.3-0.3,4.2-1.7,5.8-3.2c0.6-0.5,1.2-0.9,2-1.2c0.2-0.1,0.4,0.1,0.5,0.3 c-0.3,1.7-2.1,2.7-3.6,3.4c-1.5,0.6-3.1,1-4.6,1.4C339.5,165.7,339.4,165,339.8,164.9L339.8,164.9z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1482_",
    className: "st27",
    d: "M344.6,189.5h-8.2c-2.2,0-4-1.8-4-4v-11.8c0-2.2,1.8-4,4-4h9.9c1.2,0,2.2,1,2.2,2.2v13.6 C348.6,187.7,346.8,189.5,344.6,189.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1481_",
    x: 331.7,
    y: 169,
    className: "st28",
    width: 17.9,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1480_",
    x: 332.5,
    y: 172.2,
    className: "st29",
    width: 16.1,
    height: 1.1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 191.9,
    className: "st30",
    width: 4.7,
    height: 97.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.5,
    y: 189.3,
    className: "st31",
    width: 115.6,
    height: 4.1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M236.4,218.5c-2.7-16-8.5-60.2,9.7-68.1c7-2.5,17,0.3,21.5,6.5c4.1,5.5,3.8,12.1,4.7,18.4 c1.2,11.8,1.7,23.8,1.5,35.6c0,1-0.9,1.9-1.9,1.8c-1,0-1.8-0.8-1.8-1.8c-0.7-11.7-1.9-23.4-3.3-35.1c-0.7-4.1-0.8-8.5-2.2-12.4 c-2-6.2-9.3-8.5-14.9-8c-12.3,2.8-11.3,34.6-11,44.9c0.2,5.9,0.6,11.8,1.2,17.6C240,220.1,236.9,220.6,236.4,218.5L236.4,218.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M249,154.6c0.9,14.7,0.7,29.5,0,44.2c-0.2,4.9-0.5,9.8-1,14.7c-0.2,1.9-3,1.8-3.1-0.1 c-0.9-14.7-0.5-29.6,0.2-44.2c0.3-4.9,0.6-9.8,1.1-14.7C246.3,152.9,248.8,152.9,249,154.6L249,154.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M259.9,153.8c1.3,19.5,1.3,39.3-0.1,58.8c-0.2,1.9-3,1.9-3.1,0c-0.8-9.6-0.8-19.7-0.8-29.4 c0.1-9.8,0.3-19.6,1.2-29.4C257.2,152.1,259.7,152.1,259.9,153.8L259.9,153.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M240.2,225.3c0.7,18.1,0.1,36.4-1.9,54.4c-0.3,1.9-3,1.8-3.1-0.1c-0.6-13.5,0-27.3,0.9-40.8 c0.3-4.5,0.7-9,1.3-13.6C237.5,223.5,240.1,223.6,240.2,225.3L240.2,225.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M268.7,226.5c1,17.7,0.8,35.5-0.9,53.1c-0.2,1.9-3,1.8-3.1-0.1c-0.6-8.7-0.6-17.8-0.4-26.6 c0.2-8.9,0.6-17.7,1.6-26.6C266,224.7,268.6,224.8,268.7,226.5L268.7,226.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M254.2,226.5c1.4,14.2,1.5,28.6,0.1,42.9c-0.2,1.8-2.9,1.8-3.1,0c-1.1-10.6-1.1-21.5-0.7-32.1 c0.2-3.6,0.4-7.1,0.8-10.7C251.5,224.8,254,224.8,254.2,226.5L254.2,226.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M288,220.7c3.6,18.6,6,37.6,6.8,56.5c0,1.9-2.7,2.2-3.1,0.4c-2.8-13.9-4.4-28.2-5.7-42.3 c-0.4-4.7-0.7-9.5-0.9-14.2C285.1,219.4,287.6,219,288,220.7L288,220.7z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "st30",
    cx: 262,
    cy: 221.1,
    rx: 26.3,
    ry: 12.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M287.9,223.3c-2.2,5.8-12.9,10.1-25.9,10.1c-14.5,0-26.3-5.5-26.3-12.3c0-0.6,0.1-1.1,0.2-1.6 c0,0,3.6,7.6,24.2,8.4C280.8,228.7,287.9,223.3,287.9,223.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1526_",
    className: "st4",
    d: "M303.7,272.4l0.1,4.4c0,0,2.6,0.8,5.7-0.3c0,0,1.6-0.5,2.2-1l-0.3-3.8L303.7,272.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1514_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1525_",
    className: "st5",
    d: "M303.2,278.8c0,0.4,0,0.7,0.1,1.2c0,0.3,0,0.5,0.2,0.7c0.2,0.4,0.7,0.5,1.1,0.6 c1.3,0.3,9.6,1.9,12.9,0.7c1-0.4,2.2-0.9,2.4-1.9c0.2-1-0.9-1.7-1.8-2.2l-14.8-0.4L303.2,278.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1524_",
    className: "st25",
    d: "M303.2,278.8c0-0.9,0-1.3,0.4-2.6l1.3,0.2c1.5,0.2,2.5-0.2,2.5-0.2s2.7-0.7,4.3-1.7 c0,0,1.6,1.2,2.4,1.6c1.3,0.7,2.6,1.3,3.9,2l0,0.1c-0.3,0-0.6,0.2-0.9,0.4c-0.5,0.3-0.9,0.7-1.2,1.2c-0.1,0.2-0.3,0.4-0.3,0.6 c-0.1,0.2-0.1,0.5,0,0.7C311.3,281.4,306.8,280.7,303.2,278.8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1515_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1522_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M316.2,277.2c-0.8,0.3-1.4,0.8-1.7,1.6c0,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.1-0.1-0.1-0.1c0-1,1-1.8,2-1.8 C316.3,276.9,316.4,277.2,316.2,277.2L316.2,277.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1520_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M315,276.7c-0.8,0.4-1.4,0.9-1.8,1.7c0,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.1-0.1-0.1-0.2c0.2-1,1-1.7,2-1.8 C315.1,276.4,315.2,276.6,315,276.7L315,276.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1518_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M313.9,276.1c-0.8,0.3-1.4,0.8-1.7,1.6c0,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.1-0.1-0.1-0.2c0.1-1,1-1.8,2-1.8 C314,275.8,314,276,313.9,276.1L313.9,276.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1516_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M312.6,275.4c-0.7,0.4-1.5,0.8-1.6,1.7c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.1-0.1-0.1-0.1 c-0.3-1.1,0.9-1.8,1.8-2C312.7,275.1,312.8,275.3,312.6,275.4L312.6,275.4z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1513_",
    className: "st6",
    d: "M311.8,273.5c2.1-16.3,2.1-34,2.7-43.1c1.8-26.9-19.7-26.3-41.5-40 c-1.9-1.2-10.7-3-15.9-0.6c-8.9,4.1-3.3,33.7,20.4,32.6c23.7-1,21.8,31.3,25.9,51.5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1512_",
    className: "st4",
    d: "M301,278.6l0,4.1c0,0,2.9,0.7,6.1-0.7c0,0,1.6-0.7,2.3-1.3l-0.1-2.3L301,278.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1497_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1508_",
    className: "st5",
    d: "M300.5,285c0,0.4,0.1,0.8,0.2,1.3c0,0.3,0.1,0.5,0.2,0.8c0.3,0.4,0.8,0.5,1.2,0.6 c1.4,0.2,10.5,1.4,14-0.1c1.1-0.5,2.3-1.1,2.4-2.2c0.1-1.1-1.1-1.8-2.1-2.2l-16,0.7L300.5,285z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1507_",
    className: "st25",
    d: "M300.5,285c-0.1-0.9-0.1-1.4,0.2-2.9l1.4,0.1c1.6,0.1,2.7-0.4,2.7-0.4s2.9-1,4.5-2.2 c0,0,1.8,1.1,2.7,1.5c1.5,0.6,2.9,1.2,4.4,1.9l0,0.1c-0.3,0-0.6,0.2-0.9,0.4c-0.5,0.4-0.9,0.9-1.3,1.4c-0.1,0.2-0.3,0.4-0.3,0.7 c0,0.2-0.1,0.5,0,0.7C309.4,287.1,304.5,286.7,300.5,285"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1498_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1505_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M314.5,282.3c-0.8,0.3-1.5,1-1.7,1.8c0,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.1-0.1-0.1-0.1c0-1,1-2,2-2 C314.6,282,314.6,282.2,314.5,282.3L314.5,282.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1503_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M313.1,281.8c-0.8,0.4-1.4,1.1-1.8,1.9c0,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.1-0.1-0.1-0.2c0.1-1,1-1.9,2-2.1 C313.2,281.5,313.3,281.7,313.1,281.8L313.1,281.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1501_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M311.8,281.2c-0.8,0.4-1.4,1-1.8,1.8c0,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.1-0.1-0.1-0.2c0-1,1-1.9,2-2 C311.9,280.9,312,281.2,311.8,281.2L311.8,281.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1499_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M310.4,280.5c-0.7,0.5-1.6,1-1.6,1.9c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.1,0-0.1-0.1c-0.3-1.1,0.8-2,1.8-2.3 C310.5,280.2,310.6,280.5,310.4,280.5L310.4,280.5z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M247.5,126.3c0,2.8-0.1,5.8-1.9,7.9c-1.4,1.6-3.6,2.5-4.1,4.5c-0.3,1.5,0.6,3.1,0.2,4.6 c-0.3,1.4-1.5,2.3-1.9,3.7c-0.7,1.9,0.3,4,1.5,5.6c0.4,0.6,0.8,1.2,1.4,1.7c0.7,0.5,1.6,0.8,2.5,0.9c8.4,1.5,17-2.1,23.5-7.6 c1.3-1.1,2.5-2.2,3.4-3.6c1.3-1.8,2-3.9,2.6-6c1.1-4.1,1.4-8.5,1-12.7c-0.1-1.1-0.3-2.2-0.6-3.2c-0.5-1.3-1.4-2.4-2.3-3.5 c-1.6-1.9-3.2-3.9-5.5-5.1c-2.3-1.2-5.5-2.8-8.1-2.3c-5.3,1.1-7.7,3.5-9.6,6.2C247.8,119.9,247.5,123.4,247.5,126.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1496_",
    className: "st4",
    d: "M309.1,187.7c-14.8-5.2-21.8-9.9-33.2-20.6l5.8-7.3c11.9,12.7,17.9,18,30.7,23.8 c2.8,1.3,6,2,7.1,4.8c0.1,0.2,0.1,0.3,0.1,0.5c0,0.2-0.2,0.3-0.3,0.3c-0.1,0-0.2-0.1-0.3-0.2c-0.7-0.7-1.5-1.3-2.2-2 c0.5,0.5,1,1,1.5,1.5c0.2,0.2,0.4,0.4,0.3,0.7c-0.2,0.3-0.6,0.2-0.9,0c-0.6-0.4-1.3-0.9-1.9-1.3c0.8,0.6,1.7,1.2,1.9,2.2 c-0.7,0.1-1.3-0.2-1.9-0.7c-0.5-0.5-1-1-1.6-1.3c0.8,0.4,1.4,1,1.9,1.8c0.1,0.1,0.1,0.3,0.1,0.4c-0.1,0.1-0.2,0.1-0.4,0.1 c-1.4-0.4-2.4-2.1-3.9-2.1c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.2,0.2,0.5,0,0.7c-0.1,0.2-0.4,0.2-0.6,0.1c-0.2-0.1-0.4-0.2-0.5-0.3 C310.4,188.8,309.9,188,309.1,187.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1478_",
    className: "st6",
    d: "M305.1,222.6c-3.2-10.1-28.9-17.5-28.9-17.5c-8.6-1.4-10.2-15-10.2-15l-21.2-0.6 c-0.5,5.4-1,9.5-2.7,14.6c-1.7,5.1-0.4,19.4,13.3,21.5c8.3,1.3,21.8,2.7,31.7,2.3c2.3-0.1,4.3,1.4,4.9,3.5 c1.9,6.3,1.9,13.4,3.7,20.5c2.1,8.4,2.7,16.2,4.3,27.1l9.6-0.3C309.7,278.7,309.5,236.6,305.1,222.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1476_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M273.2,201.6c-0.1,0.8-0.4,1.7-0.9,2.3c-0.1,0.1-0.2,0.2-0.4,0.1c-1.6-0.6-3.2-1.2-4.8-2 c-0.1-0.1-0.2-0.2-0.1-0.3c0.1-0.1,0.2-0.2,0.3-0.1c1.7,0.5,3.3,1.1,4.8,1.7l-0.4,0.1c0.5-0.6,0.8-1.3,1-2 C272.8,201.3,273.2,201.4,273.2,201.6L273.2,201.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1470_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M272.1,203.3c8.9,3,26.3,8.4,32,15.9c2,3.6,2.5,7.6,3.2,11.6c0.6,4,1,7.9,1.3,11.9 c0.9,11.9,1.2,23.9,1.2,35.9c0,0.2-0.1,0.3-0.3,0.3l-9.4,0.3c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2c0,0,9.4-0.4,9.4-0.4 s-0.3,0.3-0.3,0.3c-0.2-15.9-0.5-31.9-2.7-47.7c-0.6-3.8-1.2-7.9-3.1-11.3c-2.2-3.2-6-5.1-9.4-7c-3.5-1.8-7.2-3.4-10.9-4.8 c-3.7-1.5-7.5-2.8-11.3-4c-0.1,0-0.2-0.2-0.1-0.3C271.8,203.4,272,203.3,272.1,203.3L272.1,203.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1466_",
    className: "st34",
    d: "M250.7,193.8c-0.6,3.6-1.3,7.1-1.9,10.7c-0.5,3-1,6.2,0.4,8.9c1.2,2.4,3.8,3.8,6.4,4.4 c2.6,0.6,5.3,0.5,8,0.5c7,0,14,0.8,20.8,2.4c3.8,0.9,7.6,2.1,10.5,4.7c4.6,4.2,5.5,11.1,6.1,17.3c1.1,10.7,2.1,21.4,3.2,32.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1462_",
    className: "st35",
    d: "M276.4,192.2c-3.3,1.2-7.7,5.1-16.9,4.8c-9.2-0.3-11.4-1.2-15.5-1 c0.1-0.7,1.2-21.2,0.7-23.2c-2.4-9.3-2.6-19,0.1-22c2.5-2.8,7.6-4.8,11.3-4c0,0,3.5,4.2,12.4,0.7c0,0,4.7,5.7,7.2,17.6 c0.8,3.9-0.6,7.5-1,11.5C274.3,180.5,275,188.5,276.4,192.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st36",
    d: "M270.2,195.2c-2.7,1.1-6.1,2-10.7,1.9c-9.2-0.3-11.4-1.2-15.5-1c0.1-0.5,0.7-12.7,0.8-19.3 c1.7,3.5-0.1,7.5,1.3,11.1C246.8,189.5,248.5,197.4,270.2,195.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1457_",
    className: "st35",
    d: "M268.5,147.5c5.7,1.8,11.1,5.6,14.5,10.5c-2.4,3.4-4.9,6.8-7.5,10l-0.8,0.7l-7-21 L268.5,147.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1456_",
    className: "st4",
    d: "M251.9,119.9c-0.8,4.8,0.1,12,1.2,15.8c0.4,1.5,0.9,3.1,1.9,4.4c5,6.1,11.5,4.1,13.6,2.6 c1.7-1.1,3-2.7,3.7-4.5c1.9-4.8,2.7-10,2.2-15.1c0,0-0.4-11.6-12.5-10.6C262,112.3,253.2,111.9,251.9,119.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1455_",
    className: "st4",
    d: "M268.5,147.5l-2-0.7v-4.3l-8-0.4l-0.1,4.7l-2.3,0c0,0,0.4,1.7,5.3,2.4 C266.2,149.9,268.5,147.5,268.5,147.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1454_",
    className: "st7",
    d: "M258.3,142.9c0,0,2.4,1.6,6,1.2c0,0-2.4,1.1-6,0.2V142.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1453_",
    className: "st37",
    points: "281.7,159.8 278.9,163.7 276.1,167.3 276.7,167.9 283.1,161.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1452_",
    className: "st7",
    d: "M257.7,130.4c0,0.4,0.4,0.7,0.8,0.7c0.4,0,0.7-0.4,0.7-0.8c0-0.4-0.4-0.7-0.8-0.7 C257.9,129.6,257.7,130,257.7,130.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1451_",
    className: "st7",
    d: "M269.4,130.5c0,0.4,0.4,0.7,0.8,0.7c0.4,0,0.7-0.4,0.7-0.8c0-0.4-0.4-0.7-0.8-0.7 C269.7,129.8,269.4,130.1,269.4,130.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1441_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M259.9,127.9c-1.4-0.1-2.7,0.2-4,0.9c-0.2,0.1-0.4,0-0.4-0.2c-0.1-0.1,0-0.2,0-0.3c1.1-1.2,3-1.6,4.5-0.9 C260.3,127.5,260.2,128,259.9,127.9L259.9,127.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1439_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M264.5,134.5c-0.9,0.7-2.3,0.2-2.6-0.8c0-0.1,0-0.2,0.1-0.3c0.1,0,0.2,0,0.2,0c0.3,0.3,0.6,0.6,1,0.7 c0.4,0.1,0.8,0.1,1.2,0C264.5,134.2,264.6,134.4,264.5,134.5L264.5,134.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1437_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M267.8,128c1.3-0.9,3.3-0.9,4.6,0.2c0.3,0.2,0,0.7-0.3,0.6c-1.4-0.4-2.7-0.5-4.1-0.2 C267.7,128.6,267.5,128.1,267.8,128L267.8,128z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1436_",
    className: "st21",
    d: "M265,127.2c0.2,1.6,0.1,3.2,0.1,4.8c0,0.1,0,0.2,0,0.2c-0.1,0.1-0.3,0.2-0.5,0.1 c-0.3,0-0.6,0-0.9,0c-0.2,0-0.4,0-0.4-0.1c-0.1-0.1-0.1-0.2-0.1-0.2c0-1.6,0.2-3.1,0.6-4.7c0-0.2,0.1-0.3,0.2-0.4 c0.2-0.2,0.5-0.2,0.7-0.1C264.6,126.8,265,126.9,265,127.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M276,191.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M275.8,169.1c-0.2-2.5-0.5-5-1.1-7.4C276,163.9,276.3,166.6,275.8,169.1L275.8,169.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M268.9,115.4c-0.4,1-1.1,1.8-1.8,2.6c-3.5,3.8-8,7-13.1,7.4c-0.4,1.2-0.8,2.5-1.2,3.7 c-0.2,0.6-0.6,1.4-1.3,1.3c-0.6-0.1-0.8-0.7-1-1.2c-0.6-2.2-0.7-4.5-0.7-6.8c0-1.1,0-2.2,0.2-3.3c0.6-2.8,2.7-5.2,5.2-6.6 c2.6-1.3,5.6-1.7,8.4-1.5c1.6,0.1,3.2,0.4,4.6,1.2C269.5,112.9,269.4,114.2,268.9,115.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1429_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1435_",
    className: "st4",
    d: "M252.6,133.4c-0.4,0.5-1,0.7-1.6,0.5c-0.4-0.2-0.8-0.5-1-0.9c-0.7-1-1.2-2.2-0.9-3.4 c0.1-0.3,0.2-0.6,0.4-0.8c0.4-0.3,1-0.3,1.4-0.1c0.4,0.2,1.2,1.1,1.6,1.5V133.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1430_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1433_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M250.2,129.8c1.1,0.3,2,1.2,2.2,2.3c0,0.1,0,0.1-0.1,0.1c-0.1,0-0.1,0-0.1-0.1c-0.4-1-1.2-1.7-2.1-2.2 C250,129.9,250.1,129.8,250.2,129.8L250.2,129.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1431_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M251.7,131.1c-0.4,0.6-0.5,1.3-0.5,2c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0-0.1-0.1c-0.2-0.7,0-1.6,0.5-2.1 C251.6,130.8,251.8,131,251.7,131.1L251.7,131.1z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M268.2,114c-0.7,1.2-0.5,2.7,0.2,3.9c0.7,1.2,1.7,2.1,2.7,3.1c2.3,2.4,4.1,5.7,3.4,9c1.5-2.1,2.2-4.4,2.1-7 s-1-5-2.4-7.1c-0.7-1-1.5-1.9-2.5-2.4C270.5,113.1,268.8,113,268.2,114z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M296.5,188.3c-2.9-3.5-2.1-12.4-2.1-12.4h15.4c0,0,0.9,8-1.4,11.8c-0.7,1.1-1.9,1.8-3.1,1.8h-6.1 C298.2,189.5,297.2,189.1,296.5,188.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M295.3,178.3c0,0-3.5-1.2-4,1.9s1.2,5.8,4.7,5.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M309.1,182.3c-1.3-1.2-1.8-0.9-2.9,0.3c-0.6,0.5-1.3,0.9-2.2,0.7c-0.9-0.2-1.4-0.9-1.9-1.2 c-0.4-0.3-1-0.5-1.5-0.3c-0.5,0.1-0.9,0.5-1.4,1c-0.5,0.5-1.5,0.9-2.3,0.5c-0.8-0.4-1.2-1-1.6-1.6c-0.1-0.2,0-0.3,0.1-0.4 c0.1-0.1,0.3,0,0.4,0.1c0.3,0.5,0.8,1,1.3,1.2c0.9,0.3,1.5-0.7,2.1-1.2c0.9-0.8,2.4-0.8,3.4-0.1c1.1,1.1,1.7,1.5,2.9,0.5 c0.5-0.4,1.1-1.1,1.9-1.1c0.9,0,1.5,0.7,1.9,1.1c0.1,0.1,0.1,0.3,0,0.4C309.4,182.4,309.2,182.4,309.1,182.3L309.1,182.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M309.1,184.2c-1.3-1.2-1.8-0.9-2.9,0.3c-0.6,0.5-1.3,0.9-2.2,0.7c-0.9-0.2-1.4-0.9-1.9-1.2 c-0.4-0.3-1-0.5-1.5-0.3c-0.5,0.1-0.9,0.5-1.4,1c-0.5,0.5-1.5,0.9-2.3,0.5c-0.8-0.4-1.2-1-1.6-1.6c-0.1-0.2,0-0.3,0.1-0.4 c0.1-0.1,0.3,0,0.4,0.1c0.3,0.5,0.8,1,1.3,1.2c0.9,0.3,1.5-0.7,2.1-1.2c0.9-0.8,2.4-0.8,3.4-0.1c1.1,1.1,1.7,1.5,2.9,0.5 c0.5-0.4,1.1-1.1,1.9-1.1c0.9,0,1.5,0.7,1.9,1.1c0.1,0.1,0.1,0.3,0,0.4C309.4,184.4,309.2,184.4,309.1,184.2L309.1,184.2z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1293_",
    className: "st4",
    d: "M288.2,184c-5,0.2-9.8-0.2-14.7-1.2c-10.5-2.1-13.8-6.1-21.7-13.4l6.7-6.2 c5.2,5.4,9,9,16.9,11.7c5,1.7,7.5,3.1,12.8,3.6c1,0.1,4.2-1.5,5.1-1.8c0.1,0,0.3-0.1,0.4,0c0.1,0.1,0.2,0.3,0.2,0.4 c0.1,0.7-0.4,1.3-1,1.7c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.1,0.1,0.2c0.3,0.3,0.8,0.4,1,0.8c0.2,0.4-0.1,0.8-0.5,0.9 c-0.4,0.1-0.8,0-1.1-0.1c0.5,0.1,0.9,0.3,1.3,0.6c0.1,0.1,0.2,0.2,0.2,0.4c0,0.2-0.2,0.2-0.4,0.3c-0.3,0.1-0.6,0-0.9-0.2 c0.4,0.1,0.8,0.3,1.1,0.7c0.1,0.1,0.2,0.2,0.2,0.4c0.1,0.4-0.4,0.7-0.7,0.5c0.3-0.1,0.7,0.1,1,0.3c0.2,0.2,0.3,0.4,0.2,0.6 c-0.1,0.2-0.4,0.3-0.6,0.3c-1,0.1-2.1-0.1-3.1-0.3C289.7,184.2,288.9,183.9,288.2,184z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "258.5,163.2 251.8,169.4 253.1,170.6 260.1,164.7  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_154_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M250.9,152.2c3.8,2.5,6.8,6.2,8.6,10.4c0.1,0.1,0,0.3-0.1,0.4c-2.8,3.1-5.9,5.9-9.2,8.4 c-0.1,0.1-0.3,0.1-0.3,0c-1.7-1.6-2.9-3.6-4-5.6c1.3,1.9,2.6,3.8,4.3,5.3c0,0-0.3,0-0.3,0c1.6-1.3,3.1-2.7,4.6-4.1 c1.5-1.4,2.9-2.9,4.4-4.4c0,0-0.1,0.4-0.1,0.4C257.1,158.7,254.3,155,250.9,152.2L250.9,152.2z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRows);
export default __webpack_public_path__ + "static/media/noRows.cb2a1f56d65f55743cf0d63299323ef5.svg";
export { ForwardRef as ReactComponent };